export const enum Orientation {
    Horizontal,
    Vertical,
}